import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { Modal, Button } from "react-bootstrap";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Permissions } from '../store/HelperStore';
import { hasPermission } from '../functions/hasPermission';
import { CurrentUser, driverCntb_historyFile } from "../DCR.dtos";
import NumberFormat from "react-number-format";


export interface FileUploadProps {
    isShowingModal: boolean;
    resetModalState: any; onFileChange: any; onOKClick: any; onDateChange: any;
    isUploadError: boolean; uploadErrorMessage: string; currentUser: CurrentUser; historyFiles?: driverCntb_historyFile[];
}

const FileUpload = function (props: FileUploadProps) {

    const [showConfirmModal, setShowConfirmModal] = useState(props.isShowingModal);
    const [uploadFile, setUploadFile] = useState<File | null>(null);
    const [uploadDate, setUploadDate] = useState<Date | null>(null);
    const [enableUpload, setEnableUpload] = useState(false);
    const [validationError, setValidationError] = useState("");
    const ContributionHistoryUploadClaim = hasPermission(Permissions.ContributionHistory_Upload, props.currentUser?.permissions);

    useEffect(
        () => {
            setShowConfirmModal(props.isShowingModal);
        },
        [props.isShowingModal]
    );

    useEffect(
        () => {
            setEnableUpload(uploadFile !== null && uploadDate !== null);
        },
        [uploadFile, uploadDate]
    )

    const onFileChange = (e:any) => {
        setUploadFile(e.target.files[0]);
        props.onFileChange(e)
    }

    function isEarlierDate() {
        const currentTime = new Date();
        //var currentMonth = (currentTime.getMonth() + 1).toString().padStart(2, "0");
        //var currentYear = currentTime.getFullYear().toString();
        //var payrollMonth = (uploadDate.getMonth() + 1).toString().padStart(2, "0");
        //var payrollYear = uploadDate.getFullYear().toString();

        //var d1 = currentMonth + "/" + currentYear; //moment(currentTime).format('MM/YYYY');
        //var d2 = payrollMonth + "/" + payrollYear; //moment(self.payrolldate()).format("MM/YYYY");

        //var parts1 = d1.split('/');
        const m1 = (currentTime?.getMonth() + 1);
        const y1 = currentTime?.getFullYear();

        //var parts2 = d2.split('/');
        const m2 = (uploadDate?.getMonth() ?? 0 + 1);
        const y2 = uploadDate?.getFullYear() ?? 0;

        if (y1 > y2) {
            return true;
        }
        else if (y1 === y2) {
            if (m1 + 1 < m2) {
                return false;
            }
            else {
                return true;
            }
        }
        else {
            return false;
        }
    }

    function isValidPayrollDt() {
        const currentTime = new Date();
        const year = new Date()?.getFullYear();
        const d2 = new Date(year, 5, 15);
        const d3 = new Date(year - 1, 0, 1);

        if (currentTime <= d2 && (uploadDate ?? new Date()) < d3) {
            return false;
        }
        else if (currentTime > d2 && (uploadDate ?? new Date()) < new Date(year, 0, 1)) {
            return false;
        }
        return true;
    }

    function isPaidOrPending(files: string | any[] | null | undefined) {
        if (files && files.length > 0) {
            const payrollDate = uploadDate?.getDate().toString().padStart(2, "0");
            const payrollMonth = ((uploadDate?.getMonth() ?? 0) + 1).toString().padStart(2, "0");
            const payrollYear = uploadDate?.getFullYear().toString();
            for (let i = 0; i < files?.length; i++) {
                const d1 = files[i]?.payroll_date;
                const d2 = payrollMonth + "/" + payrollDate + "/" + payrollYear; //moment(self.payrolldate()).format('MM/DD/YYYY');

                if ((files[i]?.status === "Pending" || files[i]?.status === "Paid") && d1 === d2) {
                    return true;
                }
            }
        }
        return false;
    }

    const validateUpload = (): boolean => {
        if (uploadFile !== null) {
            const selectedFile: File | null = uploadFile;
            const fileNameArray = selectedFile?.name.split(".");
            if (selectedFile && fileNameArray && fileNameArray?.length > 0) {
                const ext = selectedFile.name.includes(".") ? fileNameArray[fileNameArray.length-1] : "";
                if (ext?.toLowerCase() !== "csv") {
                    setValidationError("The payroll file you selected is not a valid format.  Contact Wespath if you need assistance.");
                    return false;
                }

                if (!isEarlierDate()) {
                    setValidationError("Payroll date may not be later than the next calendar month.");
                    return false;
                }

                if (!isValidPayrollDt()) {
                    setValidationError("Payroll date may not be earlier than the prior plan year. Enter a different payroll date.");
                    return false;
                }

                if (isPaidOrPending(props.historyFiles)) {
                    setValidationError("There is already an active payroll file with this date. Enter a different payroll date.");
                    return false;
                }
            }
            return true;
        }
        return false;
    }

    const clearLocalState = () => {
        setUploadDate(null);
        setShowConfirmModal(false);
        setValidationError("");
        if (props.resetModalState) {
            props.resetModalState(false);
        }
    }

    const onClickOK = () => {
        if (validateUpload()) {
            if (props.onOKClick) {
                props.onOKClick();
            }
            clearLocalState();
        }
    }

    const onClickCancel = () => {
        clearLocalState();
    }

  

    const onDateChange = (date: Date | null) => {
        setUploadDate(date);

        const dateString = (
            ('0' + ((date?.getMonth() ?? 0) + 1)).slice(-2) + '/'
            + ('0' + date?.getDate()).slice(-2) + '/'
            + date?.getFullYear());

        if (props.onDateChange) {
            props.onDateChange(dateString);
        }
    }

    return (
        <>
            <Modal show={showConfirmModal} backdrop="static" centered >
                <Modal.Header>
                    <Modal.Title>Upload Payroll File</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-justify">
                    <Row>
                        <Col>
                            <label className="control-label" style={{width: "inherit"}}>
                                <b>Select a file to upload:</b><br />
                                <input type="file" name="file" className="form-control file" onChange={(e) => onFileChange(e)} />
                            </label>
                        </Col>
                    </Row>
                    <Row className="mt-2">
                        <Col>
                            <label className="control-label">
                                <b>Enter Payroll Date (MM/DD/YYYY):</b>< br />
                            </label>
                            <DatePicker
                                selected={uploadDate}
                                onChange={(changeDate: Date) => onDateChange(changeDate)}
                                dateFormat='MM/dd/yyyy'                              
                                showYearDropdown
                                showMonthDropdown
                                customInput={
                                    <NumberFormat className="form-control" format="##/##/####" mask="_" value={uploadDate ? uploadDate.toDateString() : ""} />
                                }
                            />
                        </Col>
                    </Row>
                    {props.isUploadError &&
                        <div className="alert alert-danger mt-3" role="alert">{props.uploadErrorMessage}</div>
                    }
                    {validationError?.length > 0 &&
                        <div className="alert alert-danger mt-3" role="alert">{validationError}</div>
                    }

                </Modal.Body>
                <Modal.Footer>
                    <div className="w-100">
                        <div className="row">
                            <div className="d-none d-sm-block btn-block-xs-only float-left no-after col-12 col-sm-2">
                            </div>
                            <div className="col-12 col-sm-10">
                                <Button className="btn-block-xs-only float-right btn btn-primary" disabled={(!enableUpload || !ContributionHistoryUploadClaim)} variant="primary" onClick={() => onClickOK()}>Upload</Button>
                               
                                <Button type="button" onClick={() => onClickCancel()} className="btn-block-xs-only float-right mr-sm-3 btn btn-secondary" variant="secondary">Cancel</Button>
                            </div>
                            </div>
                        </div>                  
                </Modal.Footer>
            </Modal>
        </>
    );
};

export { FileUpload };